"use strict";
/* globals module */
/**
 * @module calendarEventRsvpAttendeeBatchRoute
 * @description BaasicCalendarEventRsvpAttendeeBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpAtendeeBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
var common_1 = require("../../../common");
var contracts_1 = require("../../../core/contracts");
var CalendarEventRsvpAttendeeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpAttendeeBatchRoute, _super);
    function CalendarEventRsvpAttendeeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-event-attendees/batch';
        _this.updateRoute = 'calendar-event-attendees/batch';
        _this.deleteRoute = 'calendar-event-attendees/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeBatchRoute.create();
     */
    CalendarEventRsvpAttendeeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeBatchRoute.update();
     */
    CalendarEventRsvpAttendeeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeBatchRoute.delete();
     */
    CalendarEventRsvpAttendeeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventRsvpAttendeeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpAttendeeBatchRoute);
    return CalendarEventRsvpAttendeeBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpAttendeeBatchRoute = CalendarEventRsvpAttendeeBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 
